import { quietLink, RecaptchaNotice } from "@/features/risk/RecaptchaAttribution";

/** The page's last line: Pax's policies, and Google's notice where reCAPTCHA runs. */
export function PageFooter({ recaptcha }: { recaptcha: boolean }) {
  return (
    <footer className="mt-auto flex h-10 items-center justify-center px-3">
      <p className="truncate text-[11px] leading-relaxed text-muted-foreground">
        <a href="/privacy" target="_blank" rel="noreferrer" className={quietLink}>
          Privacy
        </a>
        {" · "}
        <a href="/terms" target="_blank" rel="noreferrer" className={quietLink}>
          Terms
        </a>
        {recaptcha ? (
          <>
            {" · "}
            <RecaptchaNotice />
          </>
        ) : null}
      </p>
    </footer>
  );
}
